import { render } from "./MultiChoiceView.vue?vue&type=template&id=2a88f2b5"
import script from "./MultiChoiceView.vue?vue&type=script&lang=js"
export * from "./MultiChoiceView.vue?vue&type=script&lang=js"
script.render = render

export default script